export class GlobalConstants {
  public static pageSize: number = 30;
  public static xftTransactionMsDurationWarning: number = 5000;
  public static flightTransactionMsDurationWarning: number = 5000;
  public static apiMsDurationWarning: number = 1000;
}
